import linkifyHtml from "linkifyjs/html";
import sanitizeHtml from "sanitize-html";

// linkifyHtml only linkifies text nodes — any markup already present in the input
// is passed through untouched, so user-authored content must be sanitised after
// linkifying or a stored `<img onerror=...>` reaches innerHTML intact.
const LINK_ONLY = {
  allowedTags: ["a", "br"],
  allowedAttributes: { a: ["href", "target", "rel"] },
  allowedSchemes: ["http", "https", "mailto", "tel"],
};

const LINKIFY_OPTIONS = {
  attributes: {
    target: "_blank",
    rel: "noopener noreferrer",
  },
};

/**
 * Auto-links URLs in plain user text and strips everything else.
 *
 * Use for any value that ends up in `dangerouslySetInnerHTML`. Whitespace and
 * newlines survive (callers pair this with `white-space-pre-line`), and stray
 * angle brackets are dropped exactly as the browser already dropped them when
 * parsing them as unknown tags — so rendering is unchanged for real content.
 */
export const toSafeLinkedHtml = (text) =>
  sanitizeHtml(linkifyHtml(text ?? "", LINKIFY_OPTIONS), LINK_ONLY);

/**
 * Sanitises server-supplied HTML that is meant to keep basic formatting
 * (notification bodies, activity log entries). Uses sanitize-html's default
 * allow-list, which permits common inline/block formatting tags but drops
 * `<script>`, `<style>` and every event-handler attribute.
 */
export const toSafeRichHtml = (html) => sanitizeHtml(html ?? "");
